import React, { useMemo } from 'react';
import { Box, Heading } from "@chakra-ui/react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const LineGraph = React.memo(({
  chart,
  title,
  height,
  lineDataKey = "total",
  lineName = "Total",
}) => {
  const chartData = useMemo(() => chart, [chart]);

  const chartHeight = height ? parseInt(height) : 300;

  return (
    <Box width="100%">
      <ResponsiveContainer width="100%" height={chartHeight} debounce={300}>
        <LineChart
          data={chartData}
          margin={{
            top: 10,
            right: 10,
            left: -10,
            bottom: 15,
          }}
        >
          <CartesianGrid stroke="#EBEBEB" vertical={false} />
          <XAxis
            dataKey="hour"
            name="Hour"
            axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
          />
          <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />

          <Tooltip />
          <Legend width="100%" />
          <Line
            type="monotone"
            strokeWidth={1.6}
            dataKey={lineDataKey}
            name={lineName}
            stroke={"var(--blue)"}
            dot={{ fill: "var(--blue)", r: 2 }}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
      <Heading
        size="sm"
        fontWeight={400}
        fontSize="14px"
        color="#535353"
        mb="20px"
        textAlign="center"
      >
        {title}
      </Heading>
    </Box>
  );
});

export default LineGraph;
